import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
import { relativeTimeRounding } from "moment";

export const locationListStyle = {
  fieldRowHeading: {
    retro: {
      padding: "10px",
      fontSize: "12px",

      backgroundColor: "var(--fourth)",
      fontWeight: 600,
    },
    electric: {
      padding: "10px",
      fontSize: "12px",

      backgroundColor: electricColors.fourth,
      fontWeight: 600,
    },
  },
  fieldRowHeadingv2: {
    retro: {
      padding: "10px",
      fontSize: "12px",
      borderBottom: "1px solid " + "var(--ten)",
      backgroundColor: "var(--fifth)",
      cursor: "pointer",
    },
    electric: {
      padding: "10px",
      fontSize: "12px",
      borderBottom: "1px solid " + electricColors.ten,
      backgroundColor: electricColors.fifth,
      cursor: "pointer",
    },
  },
  addNewField: {
    retro: {
      position: "relative",
      padding: "6px 9px 9px 12px",
      right: 0,
      color: "var(--first)",
      cursor: "pointer",
    },
    electric: {
      position: "relative",
      padding: "6px 9px 9px 12px",
      right: 0,
      color: electricColors.first,
      cursor: "pointer",
    },
  },
  mainContainer: {
    retro: {
      backgroundColor: "var(--fifth)",
    },
    electric: {
      backgroundColor: electricColors.fifth,
    },
  },
  addIconStyle: {
    retro: {
      position: "relative",
      left: "90%",
      verticalAlign: "middle",
    },
    electric: {
      position: "relative",
      left: "90%",
      verticalAlign: "middle",
    },
  },

  addNewInputField: {
    retro: {
      width: "-webkit-calc(100% - 76px)",
      width: " -moz-calc(100% - 76px)",
      width: "      calc(100% - 76px)",
      height: "34px",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: "var(--second)",
      backgroundColor: "var(--fifth)",
      backgroundImage: "none",
      border: "1px solid " + "var(--ten)",
      borderRadius: "0px",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
    electric: {
      width: "-webkit-calc(100% - 76px)",
      width: " -moz-calc(100% - 76px)",
      width: "      calc(100% - 76px)",
      height: "34px",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: electricColors.second,
      backgroundColor: electricColors.fifth,
      backgroundImage: "none",
      border: "1px solid " + electricColors.ten,
      borderRadius: "0px",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
  },
  saveInputIcon: {
    retro: {
      color: "var(--first)",
      display: "inline-block",
      height: "34px",
      padding: "6px 9px 9px 12px",
      cursor: "pointer",
    },
    electric: {
      color: electricColors.first,
      display: "inline-block",
      height: "34px",
      padding: "6px 9px 9px 12px",
      cursor: "pointer",
    },
  },
  customCheckBoxContainer: {
    retro: {
      background: "var(--fifth)",
      cursor: "pointer",
      padding: "0px 2px",
      minHeight: "20px",
      minWidth: "21px",
      borderRadius: "2px",
      border: "1px solid " + "var(--first)",
    },
    electric: {
      background: electricColors.fifth,
      cursor: "pointer",
      padding: "0px 2px",
      minHeight: "20px",
      minWidth: "21px",
      borderRadius: "2px",
      border: "1px solid " + electricColors.first,
    },
  },
  editIcon: {
    retro: {
      color: "var(--second)",
      padding: "0px 0px 0px 10px",
      cursor: "pointer",
    },
    electric: {
      color: electricColors.second,
      padding: "0px 0px 0px 10px",
      cursor: "pointer",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/LocationSetup/LocationListStyle.js